module.exports = __webpack_public_path__ + "static/media/zer01ne.06c27c29.png";